// ========== Imports ==========
import React from 'react';
import QRCode from 'react-qr-code';
import { renderToStaticMarkup } from 'react-dom/server';
import { amtStr } from 'helpers/StringNumberFunction/numFormatter';
import { dateFormat } from 'helpers/StringNumberFunction/formatDate';
import { moneyFunction } from 'helpers/StringNumberFunction/moneyFunction';

const generateQRCodeSVG = value => {
  const qrCodeElement = (
    <QRCode
      size={128}
      style={{ height: '75px', width: '75px' }}
      value={value}
      // viewBox={`0 0 128 128`}
    />
  );
  return renderToStaticMarkup(qrCodeElement);
};

// ========== Component ==========
export const ELetterServiceSupplier = ({
  docType,
  previewDetail,
  allpreviewDetail,
  paramVal,
  ItemIndex,
  approvalLog,
}) => {
  let APInvoice;

  // ========== Get Company Details from local storage ==========
  const companyDetails = JSON.parse(localStorage.getItem('companyDetails'));

  // ========== Watermark ==========
  const watermark =
    previewDetail?.receiptStatus === 'SUBMIT'
      ? 'DRAFT'
      : previewDetail?.receiptStatus === 'APPROVED'
      ? companyDetails?.watermarkWording ?? ''
      : '';

  let approverNameL1 = '';
  let approvalDateL1 = '';
  let roleNameL1 = '';
  let approverNameL2 = '';
  let approvalDateL2 = '';
  let roleNameL2 = '';
  let approverNameL3 = '';
  let approvalDateL3 = '';
  let roleNameL3 = '';

  if (approvalLog && approvalLog.length > 0) {
    const completedWorkflow = approvalLog.find(
      wf => wf.workFlowStatus === 'COMPLETED',
    );

    if (completedWorkflow?.workflowStep) {
      // Filter only approved steps and sort by stepNo
      const approvedSteps = completedWorkflow.workflowStep
        .filter(step => step.approvalStatus === 'APPROVED')
        .sort((a, b) => a.stepNo - b.stepNo);

      approvedSteps.forEach(step => {
        if (step.stepNo === 1) {
          approverNameL1 = step.name || '';
          approvalDateL1 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL1 = step.roleName || '';
        } else if (step.stepNo === 2) {
          approverNameL2 = step.name || '';
          approvalDateL2 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL2 = step.roleName || '';
        } else if (step.stepNo === 3) {
          approverNameL3 = step.name || '';
          approvalDateL3 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL3 = step.roleName || '';
        }
      });
    }
  }

  const bankAddress = previewDetail?.bankAccount?.bankProfile?.address;

  // ========== Construct Creditor/Supplier Details ==========
  const creditorDetails = {
    '[supplierName]': previewDetail?.supplier?.name ?? '',
    '[supplierAddress]': `${previewDetail?.supplier?.address?.address ??
      ''}<br />
      ${
        previewDetail?.supplier?.address?.country === 'Singapore'
          ? `${previewDetail?.supplier?.address?.country} ${previewDetail?.supplier?.address?.postCode}`
          : `${previewDetail?.supplier?.address?.postCode} ${previewDetail?.supplier?.address?.city}, 
        ${previewDetail?.supplier?.address?.state}, ${previewDetail?.supplier?.address?.country}`
      }
      <br />`,
    '[supplierContactPerson]':
      previewDetail?.supplier?.contactPerson?.[0]?.name! ?? '',
    '[supplierContactNo]': previewDetail?.supplier?.contactNo! ?? '',
    '[supplierPicContactNo]':
      previewDetail?.supplier?.contactPerson?.[0]?.contactNo! ?? '',
    '[supplierEmail]':
      previewDetail?.supplier?.contactPerson?.length > 0
        ? previewDetail?.supplier?.contactPerson[0]?.email!
        : '',
    '[supplierTinNo]': previewDetail?.supplier?.tinNo ?? '',
    '[supplierRegNo]': previewDetail?.supplier?.registrationNo ?? '',

    // ========== Additional (Not Used) Fields ==========
    '[CreditorCompanyRegNo]':
      previewDetail?.CreditorAccount?.CompanyRegNo! ?? '',
    '[CreditorBankAccName]': previewDetail?.CreditorAccount?.BankName! ?? '',
    '[CreditorBankAccNo]': previewDetail?.CreditorAccount?.BankAccountNo! ?? '',
    '[CreditorTIN]': previewDetail?.CreditorAccount?.einvoice_TIN! ?? '',
    '[CreditorSSTRegNo]': previewDetail?.SSTRegNo! ?? '',
    '[CreditorGSTRegNo]': previewDetail?.GSTRegNo! ?? '',

    // ========== Document Metadata ==========
    '[docNo]': previewDetail?.docNo! ?? '',
    '[docDate]': dateFormat(previewDetail?.docDate!) ?? '',
    '[docRef]': previewDetail?.docRef! ?? '',
    '[paymentDate]':
      previewDetail?.receiptStatus === 'APPROVED'
        ? dateFormat(previewDetail?.transactionDate!) ?? ''
        : dateFormat(previewDetail?.docDate!) ?? '',
    '[referenceNo]': previewDetail?.docRef! ?? '',
    '[totalAmtInWords]': moneyFunction(previewDetail?.docAmt ?? 0),
    '[docAmt]': amtStr(previewDetail?.docAmt!),
    '[contractTitle]': previewDetail?.contract?.title ?? '',
    '[creditTerm]': previewDetail?.contract?.creditTerm ?? '',

    // ========== QR Code ==========
    '[qrCode]':
      previewDetail?.isEInvoice && previewDetail?.eInvoiceQrUrl
        ? generateQRCodeSVG(previewDetail?.eInvoiceQrUrl)
        : '',

    // ==========================
    // BANK DETAILS
    // ==========================
    '[bankName]': previewDetail?.bankDetails?.name ?? '',
    '[bankAddress]': `${bankAddress?.address}, ${bankAddress?.city},
          ${bankAddress?.state}, ${bankAddress?.country}, ${bankAddress?.postCode}`,
    '[bankAccountNo]': previewDetail?.bankDetails?.acctNo ?? '',
    '[bankSwiftCode]': previewDetail?.bankAccount?.swiftCode ?? '',

    // ============================
    // Currency
    // ============================
    '[companyCurrency]':
      // previewDetail?.user?.companyCurrency! ?? companyDetails?.currency ?? '',
      (companyDetails?.currency && companyDetails?.currency == 'Ringgit'
        ? 'Malaysian Ringgit'
        : companyDetails?.currency) ?? '',
    '[companyCurrencyCode]':
      previewDetail?.user?.companyCurrencyCode! ??
      companyDetails?.currencyCode ??
      '',
    '[currency]': previewDetail?.currencyByDoc?.name ?? '',
    '[currencyRate]': (previewDetail?.exchangeRate ?? 1.0).toFixed(8) ?? '',
    '[localDocAmt]': amtStr(previewDetail?.localDocAmt),

    '[approverNameL1]': approverNameL1,
    '[approvalDateL1]': approvalDateL1,
    '[roleNameL1]': roleNameL1,
    '[approverNameL2]': approverNameL2,
    '[approvalDateL2]': approvalDateL2,
    '[roleNameL2]': roleNameL2,
    '[approverNameL3]': approverNameL3,
    '[approvalDateL3]': approvalDateL3,
    '[roleNameL3]': roleNameL3,
  };

  // ========== Document Type Processing ==========
  switch (docType) {
    // =========================
    // PAYMENT
    // =========================
    case 'payment':
      return Object.assign(paramVal, creditorDetails, {
        //This Parameter has been added to differentiate both draft status/approved status
        '[watermark]': watermark,

        // Header Information
        '[docNo]': previewDetail?.docNo!,
        '[documentDate]': dateFormat(previewDetail?.docDate!),
        '[ReferenceNo]': previewDetail?.RefNo! ?? '',
        '[description]': previewDetail?.description! ?? '',
        '[transactionStatus]': previewDetail?.receiptStatus,
        '[bankAccountCode]': previewDetail?.bankAccount?.code! ?? '',

        // Not Used Fields
        '[Remark]': previewDetail?.Remark! ?? '',
        '[PaymentMethod]': previewDetail?.PaymentMethod?.Name! ?? '',
        '[ChequeNo]': previewDetail?.ChequeNo! ?? '',
        '[CompanyBankAccCode]': previewDetail?.BankAccount?.Code! ?? '',
        '[CompanyBankAccNo]': previewDetail?.BankAccount?.AccountNo! ?? '',

        // Item Listing
        items: previewDetail?.allocation?.map((el, i) => ({
          '[Index]': ItemIndex ?? 0 + i + 1,
          '[itemDocDate]': el?.docDate ? dateFormat(el?.docDate) : '',
          '[itemDocNo]': el?.docNo ?? '',
          '[AllocationRefNo]': el?.docRef ?? '',
          '[itemDescription]': el?.description ?? '',
          '[itemDocAmt]': amtStr(el?.docAmt ?? 0),
          '[itemAllocatedAmt]': amtStr(el?.allocatedByDoc ?? 0),
          '[itemOutstandingAmt]': amtStr(el?.outstandingAmt ?? 0),
          '[itemPayAmt]': amtStr(el?.allocatedByDoc ?? 0),
          '[AllocDefaultAmt]': amtStr(el?.docAmt ?? 0),
          subItem: el?.AllocatedDocs?.map((v, index) => ({
            '[SubItemIndex]': index + 1,
            '[AllocatedDetail]': `${v?.DebitDocNo!} ${dateFormat(
              v?.DebitDocDate!,
            )} - ${v?.DebitDescription!}`,
            '[AllocatedDocAmt]': !!v?.AllocationAmt
              ? `(${amtStr(v?.AllocationAmt!)})`
              : 0,
          })),
        })),
        '[SumAllocationAmt]': amtStr(
          allpreviewDetail?.Allocation?.reduce(
            (a, b) => a + Number(b?.AllocationAmt!),
            0,
          ),
        ),
      });

    // =========================
    // DEPOSITS
    // =========================
    case 'deposits':
      return Object.assign(paramVal, creditorDetails, {
        '[description]': previewDetail?.description! ?? '',
        '[Remark]': previewDetail?.Remark! ?? '',
        '[TotalAmt]': amtStr(previewDetail?.DocAmt!),
        '[SumTotalAmt]': amtStr(previewDetail?.DocAmt!),
        '[PaymentMethod]': previewDetail?.PaymentMethod?.Name! ?? '',
        '[ChequeNo]': previewDetail?.ChequeNo! ?? '',
        '[CompanyBankAccCode]': previewDetail?.BankAccount?.Code! ?? '',
        '[CompanyBankAccNo]': previewDetail?.BankAccount?.AccountNo! ?? '',
      });

    // =========================
    // REFUND (not used)
    // =========================
    case 'refund':
      return Object.assign(paramVal, creditorDetails, {
        '[Description]': previewDetail?.Description! ?? '',
        '[Remark]': previewDetail?.Remark! ?? '',
        '[RefundMethod]': previewDetail?.PaymentMethod?.Name! ?? '',
        '[ChequeNo]': previewDetail?.ChequeNo! ?? '',
        '[CompanyBankAccCode]': previewDetail?.BankAccount?.Code! ?? '',
        '[CompanyBankAccNo]': previewDetail?.BankAccount?.AccountNo! ?? '',
        items: previewDetail?.Allocation?.map((el, i) => ({
          '[AllocationDocDate]': dateFormat(
            el?.DebitDocDate! ?? el?.CreditDocDate!,
          ),
          '[AllocationDocNo]': el?.DebitDocNo! ?? el?.CreditDocNo! ?? '',
          '[AllocationRefNo]': el?.DebitRefNo! ?? el?.CreditRefNo! ?? '',
          '[AllocationRemark]': el?.Description! ?? '',
          '[AllocationAmt]': amtStr(el?.AllocationAmt!),
        })),
        '[SumAllocationAmt]': allpreviewDetail?.Allocation?.reduce(
          (a, b) => a + Number(b?.AllocationAmt),
          0,
        ).toFixed(2),
      });

    // =========================
    // INVOICE
    // =========================
    case 'invoice':
      return Object.assign(paramVal, creditorDetails, {
        '[description]': previewDetail?.description! ?? '',
        '[Remark]': previewDetail?.Remark! ?? '',
        items: previewDetail?.invoiceToSupplierItem?.map((el, i) => ({
          '[Index]': ItemIndex + i + 1,
          '[itemDescription]': el?.costItem?.name!,
          '[taxRate]': el?.taxRate! + '%',
          '[principalAmt]': amtStr(el?.docAmt! - el?.taxAmt!),
          '[itemTaxAmt]': amtStr(el?.taxAmt!),
          '[itemTotalAmt]': amtStr(el?.docAmt!),
        })),
      });

    // =========================
    // CREDIT NOTE
    // =========================
    case 'credit-note':
      return Object.assign(paramVal, creditorDetails, {
        '[description]': previewDetail?.description! ?? '',
        '[Remark]': previewDetail?.Remark! ?? '',
        items: previewDetail?.CNtoSupplierItem?.map((el, i) => ({
          '[Index]': ItemIndex + i + 1,
          '[itemDescription]': el?.costItem?.name!,
          '[taxRate]': el?.taxRate! + '%',
          '[principalAmt]': amtStr(el?.docAmt! - el?.taxAmt!),
          '[itemTaxAmt]': amtStr(el?.taxAmt!),
          '[itemTotalAmt]': amtStr(el?.docAmt!),
        })),
        // Not Used Allocation Section
        allocItems: previewDetail?.Allocation?.map((el, i) => ({
          '[AllocIndex]': i + 1,
          '[AllocDocDate]': dateFormat(el?.CreditDocDate!),
          '[AllocDocNo]': el?.CreditDocNo!,
          '[AllocDesc]': el?.Description!,
          '[AllocAmt]': amtStr(el?.AllocationAmt!),
        })),
        '[SumBaseAmt]': allpreviewDetail?.APCreditNoteItem?.reduce(
          (a, b) => a + Number(b?.Amount),
          0,
        ).toFixed(2),
        '[SumTaxAmt]': amtStr(
          allpreviewDetail?.APCreditNoteItem?.reduce(
            (a, b) => a + Number(b?.TaxAmt),
            0,
          ).toFixed(2),
        ),
        '[SumTotalAmt]': amtStr(
          allpreviewDetail?.APCreditNoteItem?.reduce(
            (a, b) => a + Number(b?.DocAmt),
            0,
          ).toFixed(2),
        ),
      });

    // =========================
    // DEBIT NOTE
    // =========================
    case 'debit-note':
      return Object.assign(paramVal, creditorDetails, {
        '[description]': previewDetail?.description! ?? '',
        '[Remark]': previewDetail?.Remark! ?? '',
        items: previewDetail?.DNtoSupplierItem?.map((el, i) => ({
          '[Index]': ItemIndex + i + 1,
          '[itemDescription]': el?.costItem?.name!,
          '[taxRate]': el?.taxRate! + '%',
          '[principalAmt]': amtStr(el?.docAmt! - el?.taxAmt!),
          '[itemTaxAmt]': amtStr(el?.taxAmt!),
          '[itemTotalAmt]': amtStr(el?.docAmt!),
        })),
        '[SumBaseAmt]': allpreviewDetail?.APDebitNoteItem?.reduce(
          (a, b) => a + Number(b?.Amount),
          0,
        ).toFixed(2),
        '[SumTaxAmt]': amtStr(
          allpreviewDetail?.APDebitNoteItem?.reduce(
            (a, b) => a + Number(b?.TaxAmt),
            0,
          ).toFixed(2),
        ),
        '[SumTotalAmt]': amtStr(
          allpreviewDetail?.APDebitNoteItem?.reduce(
            (a, b) => a + Number(b?.DocAmt),
            0,
          ).toFixed(2),
        ),
      });
  }
};
